export const STEP_SELECT_TYPE = 'select-type';
export const STEP_SUCCESS = 'success';
export const STEP_INFO = 'info';

export type ProcessBoxOfficeStep = typeof STEP_SELECT_TYPE | typeof STEP_SUCCESS | typeof STEP_INFO;
export interface BoxOfficeForm {
  eventId: string;
  offerId: string;
  channelId: string;
  quantity: number;
  bookingFormFields: {
    email?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    gender?: string;
    nationality?: string;
    birth?: string;
  };
  ticketHolderFormFields: [];
}
